import React from 'react';
import NavBar from './NavBar';
import MobileNavBar from './MobileNavBar';
import Content from './Content';

class App extends React.Component {

    render() {
        return (
            <div id="page" className="page">
                <NavBar
                    siteTitle="Muneeb Shahid"
                    siteDescription="Full Stack Engineer"
                />
                <MobileNavBar siteTitle="Muneeb Shahid" />
                <Content
                    name="Muneeb Shahid"
                    designation1="Research Assistant"
                    email="muneeb706@gmail.com"
                    githubLink="https://github.com/muneeb706"
                    aboutmeDescription="Front End, Back End, Database, and Dev OPS"
                />
            </div>
        );
    }
}

export default App;
